<i #popup class="ui {{ icon }} icon popup-activator" data-position="bottom left" data-variation="very wide"></i>
<div class="ui popup popup--tooltip">
    <ng-content></ng-content>
</div>
